import React from 'react';

const Footer = () => {
  return <footer className='bg-primary p-12'>
    <div className='container mx-auto'>
      <p className='text-white text-center'>Copyright &copy; eCommerce App 2023. All rights reserved.</p>
    </div>
  </footer>;
};

export default Footer;